module.exports = __webpack_public_path__ + "img/bx-classroom-manage-active.779301b3.svg";